import { createFileRoute } from '@tanstack/react-router';
import { MyTracksPage } from '@/page/MyTracksPage';

export const Route = createFileRoute('/_app/library/mine')({ component: MyTracksPage });
